import * as moment from 'moment';
import { DateTimeConverter } from '../../../core/services/mapper/converters';
import { ClassConverterFactory } from '../../../core/services/mapper/data-property.converter';
import { Operateur } from '../../intervenant/models/operateur.model';

export class EchantillonExport {
    static jsonMap = {
        // Echantillon
        idEchantillon: { key: 'idEchantillon' },
        numeroEchantillon: { key: 'numeroEchantillon', optional: true, default: '' },
        millesimeEchantillon: { key: 'millesimeEchantillon' },

        // Intervenant (operateur)
        idIntervenant: { key: 'idIntervenant' },
        cviIntervenant: { key: 'cviIntervenant', optional: true, default: '' },
        intervenant: { key: 'intervenant', converter: new (ClassConverterFactory.build(Operateur))(), optional: true },

        // Cahier des charges / Produit / Couleur
        cahiers: { key: 'cahiers', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        couleur: { key: 'couleur', optional: true, default: '' },

        // Mouvement à l'origine de l'échantillon
        idMouvement: { key: 'idMouvement' },
        typeMouvement: { key: 'typeMouvement', optional: true, default: '' },
        adresseSiteStockage: { key: 'adresseSiteStockage', optional: true, default: '' },
        cepages: { key: 'cepages', optional: true, default: '' },
        tav: { key: 'tav', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        logementLot: { key: 'logementLot', optional: true, default: '' },
        volumeLot: { key: 'volumeLot' },
        detailsContenants: { key: 'detailsContenants', optional: true, default: '' },

        dateEvenement: { key: 'dateEvenement', converter: new DateTimeConverter(), optional: true },

        // Prélèvement
        typePrelevement: { key: 'typePrelevement', optional: true, default: '' },

        // Controle / expertise
        numeroExpertise: { key: 'numeroExpertise' },
        numeroPassage: { key: 'numeroPassage' },
        dateButoirControle: { key: 'dateButoirControle', converter: new DateTimeConverter(), optional: true },

        // Tournée
        referenceTournee: { key: 'referenceTournee', optional: true, default: '' },
        dateTournee: { key: 'dateTournee', converter: new DateTimeConverter(), optional: true },
        idIntervenantTournee: { key: 'responsableTournee', optional: true },
        intervenantTournee: { key: 'intervenantTournee', converter: new (ClassConverterFactory.build(Operateur))(), optional: true },

        // Commission / jury / degustation
        referenceCommission: { key: 'referenceCommission', optional: true, default: '' },
        dateCommission: { key: 'dateCommission', converter: new DateTimeConverter(), optional: true },
        numeroJury: { key: 'numeroJury', optional: true, default: '' },
        numeroAnonymat: { key: 'numeroAnonymat', optional: true, default: '' },
        resultatDegustation: { key: 'resultatDegustation', optional: true, default: '' }
    };

    // Echantillon
    idEchantillon: number;
    numeroEchantillon: string;
    millesimeEchantillon: number;

    // Intervenant (operateur)
    idIntervenant: number;
    cviIntervenant: string;
    intervenant: Operateur;

    // Cahier des charges / Produit / Couleur
    cahiers: string;
    produit: string;
    couleur: string;

    // Mouvement à l'origine de l'échantillon
    idMouvement: number;
    typeMouvement: string;
    adresseSiteStockage: string;
    cepages: string;
    tav: string;
    numeroLot: string;
    logementLot: string;
    volumeLot: number;
    detailsContenants: string;

    dateEvenement: moment.Moment;

    // Prélèvement
    typePrelevement: string;

    // Controle / expertise
    numeroExpertise: number;
    numeroPassage: number;
    dateButoirControle: moment.Moment;

    // Tournée
    referenceTournee: string;
    dateTournee: moment.Moment;
    idIntervenantTournee: number;
    intervenantTournee: Operateur;

    // Commission / jury / degustation
    referenceCommission: string;
    dateCommission: moment.Moment;
    numeroJury: string;
    numeroAnonymat: string;
    resultatDegustation: string;
}
